import { BlockedActionMode } from '_lib/auth/rbac';
import { Tooltip } from '@material-ui/core';
import React, { ReactElement } from 'react';

interface RoleGuardProps {
  allowed: boolean;
  blockedActionMode: BlockedActionMode;
  blockedMessage: string;
  children: ReactElement;
}

const RoleGuard = ({
  allowed,
  blockedActionMode,
  blockedMessage,
  children,
}: RoleGuardProps): ReactElement | null => {
  if (allowed) return children;
  if (blockedActionMode === 'hide') return null;

  return (
    <Tooltip title={blockedMessage}>
      <span
        style={{ display: 'inline-flex', opacity: 0.5, cursor: 'not-allowed' }}
        onClick={(event) => {
          event.preventDefault();
          event.stopPropagation();
        }}
      >
        <span style={{ pointerEvents: 'none', display: 'inline-flex' }}>{children}</span>
      </span>
    </Tooltip>
  );
};

export { RoleGuard };
export default RoleGuard;
